export class Logger {
    private static curGroup: string = null;
    private static supportGroups: boolean = null;

    public static debug(...args: any[]) {
        Logger.closeGroup();

        console.log.apply(console, [].slice.call(args, 0));
    }

    public static error(msg: string, e?: Error | string, ...args: any[]) {
        Logger.closeGroup();

        console.error(msg, e, [].slice.call(args, 0));
    }

    private static doSupportGroups(): boolean {
        if (Logger.supportGroups === null) {
            Logger.supportGroups = console.groupEnd !== undefined &&
                console.groupCollapsed !== undefined &&
                console.group !== undefined;
        }

        return Logger.supportGroups;
    }

    private static closeGroup(): void {
        if (Logger.curGroup !== null) {
            console.groupEnd();
            Logger.curGroup = null;
        }
    }

    public static debugGroup(group: string, ...args: any[]) {
        if (Logger.doSupportGroups()) {
            if (Logger.curGroup !== group) {
                console.groupEnd();
                //console.groupCollapsed(Logger.curGroup = group);
                console.group(Logger.curGroup = group);
            }
            console.log.apply(console, [].slice.call(args, 0));
        } else {
            Logger.debug(`[${group}]`, args);
        }
    };

    public static errorGroup(group: string, e: Error | string, ...args: any[]) {
        if (Logger.doSupportGroups()) {
            if (Logger.curGroup !== group) {
                console.groupEnd();
                console.group(Logger.curGroup = group);
            }
            console.error.apply(console, [e].concat([].slice.call(args, 0)));
        } else {
            Logger.error(`[${group}]`, e, args);
        }
    };
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/Logger.ts
 **/